import { ChevronRight, Folder, FolderOpen } from "lucide-react";

const flatten = (folders) => {
  const out = [];
  const stack = folders.filter((f) => !f.parent_id).reverse().map((f) => ({ f, depth: 0 }));
  while (stack.length) {
    const item = stack.pop();
    const kids = folders.filter((x) => x.parent_id === item.f.id);
    out.push({ ...item, hasKids: kids.length > 0 });
    kids.reverse().forEach((k) => stack.push({ f: k, depth: item.depth + 1 }));
  }
  return out;
};

export const FolderTree = ({ folders, selected, onSelect }) => (
  <ul className="space-y-0.5" data-testid="folder-tree">
    {flatten(folders).map(({ f, depth, hasKids }) => {
      const active = selected === f.id;
      const Icon = active ? FolderOpen : Folder;
      return (
        <li key={f.id}>
          <button onClick={() => onSelect(f.id)} data-testid={`folder-${f.id}`} style={{ paddingLeft: 10 + depth * 16 }}
            className={`flex w-full items-center gap-2 rounded-lg py-2 pr-3 text-left text-sm transition-colors ${active ? "bg-primary/15 font-semibold text-primary" : "text-muted-foreground hover:bg-secondary hover:text-foreground"}`}>
            {hasKids ? <ChevronRight className="h-3 w-3 shrink-0" /> : <span className="w-3" />}
            <Icon className="h-4 w-4 shrink-0" />
            <span className="flex-1 truncate">{f.name}</span>
            <span className="font-mono text-[11px] opacity-70">{f.document_count}</span>
          </button>
        </li>
      );
    })}
  </ul>
);

export const pathTo = (folders, id) => {
  const out = [];
  let cur = folders.find((f) => f.id === id);
  while (cur) {
    out.unshift(cur);
    const parentId = cur.parent_id;
    cur = folders.find((f) => f.id === parentId);
  }
  return out;
};
